import {StyledTypography, StyledTypographyProps} from "../layout/LayoutProvider";
import * as React from "react";
import {WildcardUtility} from "../../utility/WildcardUtility";

type LocalizationTextProps = React.HTMLAttributes<HTMLDivElement> & {
   text?: string
   typographyProps?: StyledTypographyProps
   context?: any
   component?: React.ElementType;
}

export const LocalizationText = ({text, component, typographyProps, context, ...rest}: LocalizationTextProps) => {
   return <StyledTypography component={component} {...typographyProps} {...rest} dangerouslySetInnerHTML={{
      __html: WildcardUtility.replace(text || '', context, true, false)
   }}/>
}
